import React from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { ProgressSpinner } from "primereact/progressspinner";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import dynamicSurveyService, { DynamicSurveyDto } from "../../services/forms/dynamic.service";

const DynamikAnketler = () => {
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ["dynamicSurveys"],
    queryFn: () => dynamicSurveyService.getSurveys(),
  });

  const surveys: DynamicSurveyDto[] = (data?.result?.data ?? []).filter((s) => s.is_active);

  if (isLoading) {
    return (
      <div className="flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
        <ProgressSpinner />
      </div>
    );
  }

  if (surveys.length === 0) {
    return (
      <div className="flex flex-column align-items-center justify-content-center" style={{ minHeight: "300px" }}>
        <i className="pi pi-inbox text-400" style={{ fontSize: "3rem" }} />
        <p className="text-500 mt-3">Şu anda aktif anket bulunmamaktadır.</p>
      </div>
    );
  }

  return (
    <div className="p-3 md:p-4">
      <div className="mb-4">
        <h2 className="text-900 font-bold text-2xl m-0">Anketler</h2>
        <p className="text-500 mt-1 mb-0">Aşağıdaki anketlere katılabilirsiniz.</p>
      </div>
      <div className="grid">
        {surveys.map((survey) => (
          <div key={survey.id} className="col-12 md:col-6 lg:col-4">
            <Card
              className="h-full shadow-2 border-round-xl"
              style={{ borderTop: "4px solid var(--primary-color)" }}
            >
              <div className="flex flex-column h-full">
                <div className="flex align-items-start justify-content-between mb-2">
                  <h3 className="text-900 font-semibold text-lg m-0 flex-1 mr-2">{survey.title}</h3>
                  {survey.has_submitted ? (
                    <Tag value="Tamamlandı" severity="success" icon="pi pi-check" />
                  ) : survey.closure_reason === "limit_reached" ? (
                    <Tag value="Kontenjan Doldu" severity="danger" icon="pi pi-lock" />
                  ) : survey.closure_reason === "expired" ? (
                    <Tag value="Süresi Doldu" icon="pi pi-calendar-times" />
                  ) : survey.closure_reason === "not_started" ? (
                    <Tag value="Henüz Başlamadı" severity="info" icon="pi pi-clock" />
                  ) : (
                    <Tag value="Bekliyor" severity="warning" icon="pi pi-clock" />
                  )}
                </div>

                {survey.description && (
                  <p className="text-500 text-sm mt-1 mb-3 flex-1" style={{ lineHeight: "1.6" }}>
                    {survey.description}
                  </p>
                )}

                <div className="flex align-items-center justify-content-between mb-3 text-500 text-sm">
                  <div className="flex align-items-center gap-2">
                    <i className="pi pi-list" />
                    <span>{survey.questions?.length ?? 0} soru</span>
                  </div>
                  {survey.response_limit ? (
                    <div className="flex align-items-center gap-1 text-xs">
                      <i className="pi pi-users" />
                      <span>{survey.response_count ?? 0} / {survey.response_limit} yanıt</span>
                    </div>
                  ) : null}
                </div>

                <Button
                  label={
                    survey.has_submitted
                      ? "Cevaplarınız Kaydedildi"
                      : survey.closure_reason === "limit_reached"
                      ? "Kontenjan Doldu"
                      : survey.closure_reason === "expired"
                      ? "Süresi Doldu"
                      : survey.closure_reason === "not_started"
                      ? "Henüz Başlamadı"
                      : "Ankete Katıl"
                  }
                  icon={survey.has_submitted ? "pi pi-check-circle" : survey.is_closed ? "pi pi-lock" : "pi pi-pencil"}
                  disabled={survey.has_submitted || !!survey.is_closed}
                  severity={survey.has_submitted || survey.is_closed ? "secondary" : undefined}
                  className="w-full mt-auto"
                  onClick={() => navigate(`/app/anketler/${survey.share_token || survey.id}`)}
                />
              </div>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DynamikAnketler;
